import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useForm } from 'react-hook-form';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import BacklinksList from '../../components/backlinks-list/backlinks-list.component';
import DomainCard from '../../components/domain-card/domain-card.component';
import { getCategories } from '../../redux/thunks/categories';
import { isURLValid } from '../../utils/helpers/valid';
import { getErrorMessage } from '../../utils/helpers/form';
import ErrorMessage from '../../components/error-message/error-message.component';
import { ContentContainer } from './home.styles';

const Home = (props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    setValue,
    setError,
    clearErrors,
  } = useForm();
  const dispatch = useDispatch();
  const { categories } = useSelector((state) => state.entities.categories);
  const { domainBacklinks } = useSelector((state) => state.entities.backlinks);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedDomain, setSelectedDomain] = useState({});

  useEffect(() => {
    dispatch(getCategories({}));
  }, []);

  const clearAllErrors = () => {
    clearErrors('invalid');
    clearErrors('domain');
    clearErrors('categories');
  };

  useEffect(() => {
    watch(() => clearAllErrors());
  }, [watch, clearErrors]);

  const handleCategoryChange = (e) => {
    if (!e.target.value || !e.target.value.length) {
      return setSelectedCategory(null);
    }

    const foundCategory = categories.find(
      ({ name }) => name === e.target.value
    );
    if (!foundCategory) {
      return setSelectedCategory(null);
    }

    clearAllErrors();

    setSelectedCategory(foundCategory);
  };

  const handleSearch = (formData) => {
    const { domain } = formData;

    if (!domain || !domain.trim().length) {
      return setError('domain', {
        type: 'invalid',
        message: 'יש להזין דומיין',
      });
    }

    if (!isURLValid(domain)) {
      return setError('domain', {
        type: 'invalid',
        message: 'דומיין לא תקין',
      });
    }
    
    setSelectedDomain({
      excludeDomain: domain,
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      <Card>
        <Card.Body>
          <Card.Text
            style={{
              display: 'flex',
              gap: '1rem',
            }}
          >
            <Form.Control
              placeholder="דומיין"
              type="text"
              {...register('domain', {
                required: true,
              })}
            />
            <Form.Select onChange={handleCategoryChange}>
              <option>בחר קטגוריה</option>
              {categories.map((category) => (
                <option key={category._id}>{category.name}</option>
              ))}
            </Form.Select>
            <Button variant="primary" onClick={handleSubmit(handleSearch)}>
              חפש
            </Button>
          </Card.Text>
          {(errors?.domain || errors?.categories) && (
            <p>
              <ErrorMessage
                error={getErrorMessage(
                  errors?.domain?.type || errors?.categories?.type,
                  errors?.domain?.message || errors?.categories?.message
                )}
              />
            </p>
          )}
        </Card.Body>
      </Card>

      <ContentContainer>
        <BacklinksList manage={false} excludeDomain={selectedDomain.excludeDomain} selectedCategory={selectedCategory} />
        <DomainCard domain={selectedDomain.excludeDomain} backlinks={domainBacklinks} />
      </ContentContainer>
    </div>
  );
};

export default Home;
